import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest } from "../../../api/controller/TopupController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const topupListState = atom({
    key: 'topupListState',
    default: [],
})


export const modalConfigDefault = { size: "md", wizard: false }

export const topupFilterState = selector({
    key: 'topupFilterState',
    get: () => ([])
})


export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const topupDataStructureState = selector({
    key: 'topupDataStructureState',
    get: ({ get }) => (
        [
            {
                label: 'Transaction No',
                field: 'transaction_number',
                type: 'text',
                order: { table: 1 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
            {
                label: 'Date',
                field: 'date',
                type: 'date',
                order: { table: 2 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
            {
                label: 'Vessel',
                field: 'vessel_label',
                type: 'text',
                order: { table: 3 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
            {
                label: 'Subtotal',
                field: 'subtotal',
                type: 'number',
                order: { table: 4 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
            {
                label: 'GST',
                field: 'tax_amount',
                type: 'number',
                order: { table: 5 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
            {
                label: 'Total',
                field: 'net_amount',
                type: 'number',
                order: { table: 6 },
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },
            // Amount is still needed by the create form, but the table shows
            // Subtotal from the transaction instead.
            {
                label: 'Amount',
                type: 'number',
                order: { form: 1 },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'],
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
